<template>
  <div v-if="reviewCount" class="reviews-list full-width">
    <b-loading :active.sync="isLoading" :can-cancel="false" />
    <h5 v-if="showHeading" class="text-title">{{ heading }}</h5>
    <div v-if="hasRatingStatistic" class="rating-statistic rating-statistic-block">
      <RatingIcon :rating="true" :count="ratingGoodTotal"/>
      <RatingIcon :rating="false" :count="ratingBadTotal"/>
    </div>

    <nav
      v-if="hasFilter"
      class="level reviews-filter"
      style="border-bottom: 1px #ebeaf9 solid; padding-bottom: 20px"
    >
      <!-- Left side -->
      <div class="level-left"><div class="level-item" /></div>
      <!-- Right side -->
      <div class="level-right">
        <div class="level-item">
          <span class="mr-10">並べ替え</span>

          <b-field label="">
            <b-select v-model.number="sortType" placeholder="新着順">
              <option :value="1">新着順</option>
              <option :value="0">投稿順</option>
            </b-select>
          </b-field>
        </div>
      </div>
    </nav>

    <item-product-reviews
      v-for="(review, index) in reviews"
      :data="review"
      :show-link-detail="true"
      :key="index"
    />

    <div v-if="paginationType === 'number'" class="text-center pb-50">
      <b-pagination
        v-show="showPagination"
        :total="pagination.total"
        :current.sync="pagination.current + 1"
        :per-page="pagination.perPage"
        :simple="false"
        :rounded="false"
        order="is-centered"
        @change="pageChange"
      />
    </div>
    <div v-else-if="paginationType === 'link' && pagination.total > 0 && showPagination" class="page-link">
      <router-link :to="{ name: 'ProductReviewList', params: { productId } }"><b-icon icon="chevron-right"></b-icon><span>すべてのレビューを見る（{{ pagination.total }}件）</span></router-link>
    </div>
  </div>
</template>
<style lang="scss" src="./list.scss" scoped>
</style>

<script>
import RatingIcon from '@/components/common/rating-icon.vue';
import MessageArea from '@/components/common/message-area/message-area.vue';
import ItemProductReviews from '@/views/customer/components/item-reviews/item-product-reviews';
import messageUtils from '@/utils/mixins/messageUtils';
import { getReviews, getStatisticReview } from '@/services/productReview.service';

export default {
  name: 'ProductReviews',
  components: {
    MessageArea,
    ItemProductReviews,
    RatingIcon
  },
  mixins: [messageUtils],
  props: {
    id: {
      type: [String, Number],
      default: ''
    },
    hasFilter: {
      type: Boolean,
      default: true
    },
    hasRatingStatistic: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: ''
    },
    paginationType: {
      type: String,
      default: 'number'
    }
  },
  data() {
    return {
      productId: null,
      product: null,
      reviews: [],
      statistic: null,
      sortType: 1,
      pagination: {
        total: 0,
        current: 0,
        perPage: 5,
        order: '',
        size: '',
        isSimple: false,
        isRounded: false
      }
    };
  },
  computed: {
    showHeading: function() {
      return this.heading && this.heading.length > 0;
    },
    ratingGoodTotal: function() {
      return this.statistic ? this.statistic.numOfGood : '';
    },
    ratingBadTotal: function() {
      return this.statistic ? this.statistic.numOfBad : '';
    },
    reviewCount: function() {
      return this.reviews.length > 0;
    },
    showPagination: function() {
      return this.pagination && this.pagination.total > this.pagination.perPage;
    }
  },
  watch: {
    sortType: function(value) {
      this.getReviews(this.productId, this.pagination.current, this.pagination.perPage, value);
    }
  },
  created() {
    if (this.id !== null && this.id !== '') {
      this.productId = parseInt(this.id, 10);
    }

    if (this.productId !== null && this.productId !== '') {
      this.getStatistic(this.productId);
      this.getReviews(this.productId, this.pagination.current, this.pagination.perPage, this.sortType);
    }
  },
  methods: {
    async getReviews(productId, page, perPage, sortBy) {
      this.loading++;

      const { status, result } = await getReviews(productId, page, perPage, sortBy);

      if (status && result.data) {
        this.reviews = result.data.reviews;
        this.pagination.total = result.data.count;
      } else {
        this.updateMessage(status, result);
      }

      this.loading--;
    },
    async getStatistic(id) {
      this.loading++;

      const { status, result } = await getStatisticReview(id);

      if (status) {
        this.statistic = result.data;
      } else {
        this.updateMessage(status, result);
      }
      this.loading--;
    },
    async pageChange(page) {
      this.pagination.current = page - 1;
      await this.getReviews(this.productId, this.pagination.current, this.pagination.perPage, this.sortType);
    }
  }
};
</script>
